import { Button, Callout, Typography } from 'seagull';
import { StepPage } from "../../components/StepPage";
import { useResponsive } from "../../contexts";
import { useStore } from "../../../contexts";
import { relationshipModel } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import PackageSelector from "./PackageSelector";
import styles from "./PackagesStep.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PackagesStep(_ref) {
  var _relationship$service, _relationship$service2;
  let {
    selectedBundleID,
    onSelectBundleID,
    onClickNext,
    onClickBack
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    relationship
  } = useCobConfig();
  const userId = useStore(selectors.user.id);
  const isBuyer = relationshipModel.isBuyer(relationship, userId);
  const hasSignatories = relationshipModel.hasSignatories(relationship);
  return /*#__PURE__*/_jsxs(StepPage, {
    header: getStepName(COBStep.selectAPackage),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": "packages-step-next-btn",
      onClick: () => onClickNext(),
      children: "Next"
    }),
    backBtnTestid: "packages-step-back-btn",
    onBackBtnClick: onClickBack,
    testid: "packages-step",
    errorTestid: "packages-step-error",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.sectionTitle,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "normal",
        children: "Packages"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.onlyPrimaryCanSelectCallout,
      children: [!isBuyer && hasSignatories && /*#__PURE__*/_jsx("div", {
        className: styles.onlyPrimaryCanSelectCalloutContent,
        children: /*#__PURE__*/_jsxs(Callout, {
          "data-testid": "select-package-disabled-callout",
          children: ["Only ", relationshipModel.buyerFullName(relationship), " can select package for this proposal"]
        })
      }), /*#__PURE__*/_jsx(PackageSelector, {
        packages: (_relationship$service = (_relationship$service2 = relationship.serviceBundles) === null || _relationship$service2 === void 0 ? void 0 : _relationship$service2.bundles) !== null && _relationship$service !== void 0 ? _relationship$service : [],
        selectedBundleID: selectedBundleID,
        isMobile: isMobile,
        onSelect: id => onSelectBundleID(id)
      })]
    })]
  });
}